import { useEffect, useState } from "react";

import { X } from "@phosphor-icons/react";

import { useNotificationStore } from "../stores/useNotification";

// Notification Snackbar that appears whenever update resume api fails
export const NotificationBanner = () => {
  const { message, type, clear } = useNotificationStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let showTimer: NodeJS.Timeout;
    let hideTimer: NodeJS.Timeout;

    if (message) {
      setVisible(false);
      showTimer = setTimeout(() => {
        setVisible(true);
      }, 10);

      hideTimer = setTimeout(() => {
        handleDismiss();
      }, 3000);
    }

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [message]);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(() => {
      clear();
    }, 500);
  };

  if (!message) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 flex w-fit max-w-sm transform items-center rounded p-4 text-white shadow-lg transition-transform duration-500 ease-in-out ${type === "error" ? "bg-red-600" : "bg-green-600"} ${visible ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
    >
      <span>{message}</span>
      <button className="ml-4 underline" onClick={handleDismiss}>
        <X />
      </button>
    </div>
  );
};
